import { Link } from 'react-router';

// Stored link data is not validated on the server, so only these schemes pass through as written; anything else
// (javascript:, data:, ...) is treated as a bare host and gets the `//` prefix.
const EXTERNAL_URL = /^(?:(?:https?:)?\/\/|mailto:)/i;
const INTERNAL_PATH = /^\/(?![/\\])/;

function LinkDecorator({ children, contentState, entityKey, readOnly }) {
  const { internalLink, url } = contentState.getEntity(entityKey).getData();
  let fixedUrl = url.trim();
  if (!readOnly) return <span css={rootCss}>{children}</span>;
  if (internalLink && INTERNAL_PATH.test(fixedUrl))
    return (
      <Link css={rootCss} to={fixedUrl}>
        {children}
      </Link>
    );
  if (!EXTERNAL_URL.test(fixedUrl)) fixedUrl = `//${fixedUrl}`;
  return (
    <a css={rootCss} href={fixedUrl} rel="noreferrer" target={/^mailto:/i.test(fixedUrl) ? '_self' : '_blank'}>
      {children}
    </a>
  );
}

const rootCss = ({ palette }) => ({ color: palette.primary.main });

export default {
  strategy: (contentBlock, callback, contentState) => {
    contentBlock.findEntityRanges(character => {
      const entityKey = character.getEntity();
      return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
    }, callback);
  },
  component: LinkDecorator,
};
